import { Injectable } from '@angular/core';

import { EMPTY, Observable } from 'rxjs';
import { AbstractApiService } from '../../shared/services';
import * as fromModuleModels from '../models';
import { AbstractApiResponse } from '../../shared/models';
import { getUriWithPageAndParams } from '../../shared/utilities/urlParams.utility';
import { ParameterBag } from '../../shared/models/ParameterBag.interface';
import { UserRoleService } from '../../shared/services/user-role.service';

@Injectable({
  providedIn: 'root'
})
export class TicketCommentsService {
  constructor(
    private apiService: AbstractApiService,
    private rolesService: UserRoleService
  ) {}

  createTicketComment(payload: any): Observable<any> {
    return this.rolesService.userHasRoleFilter<any>(
      'ROLE_MWS_TICKET_COMMENT_CREATE',
      hasRole =>
        hasRole === false
          ? EMPTY
          : this.apiService.createObject(`/ticket_comments`, payload)
    );
  }

  readTicketComment(iri: string): Observable<any> {
    return this.rolesService.userHasRoleFilter<any>(
      'ROLE_MWS_TICKET_COMMENT_VIEW',
      hasRole =>
        hasRole === false ? EMPTY : this.apiService.getObject(iri, true)
    );
  }

  readTicketComments(
    page: number,
    params: ParameterBag
  ): Observable<AbstractApiResponse> {
    return this.rolesService.userHasRoleFilter<AbstractApiResponse>(
      'ROLE_MWS_TICKET_COMMENT_LIST',
      hasRole =>
        hasRole === false
          ? EMPTY
          : this.apiService.getObject(
              getUriWithPageAndParams('/ticket_comments', page, params)
            )
    );
  }

  readTicketCommentChunk(uri: string): Observable<AbstractApiResponse> {
    return this.rolesService.userHasRoleFilter<AbstractApiResponse>(
      'ROLE_MWS_TICKET_COMMENT_LIST',
      hasRole =>
        hasRole === false ? EMPTY : this.apiService.getObject(uri, true)
    );
  }

  updateTicketComment(
    iri: string,
    payload: fromModuleModels.TicketComment
  ): Observable<any> {
    // every user should edit their comments, so no role-based Security possible ROLE: ROLE_MWS_TICKET_COMMENT_EDIT
    return this.apiService.updateObject(iri, payload, true);
  }

  deleteTicketComment(iri: string): Observable<any> {
    // every user should edit their comments, so no role-based Security possible ROLE: ROLE_MWS_TICKET_COMMENT_DELETE
    return this.apiService.deleteObject(iri, true);
  }
}
